{
    "NAME": "DispositivoModal",
    "DeviceModal_AddTitle": "Adicionar dispositivo",
    "DeviceModal_ChangeTitle": "Alterar dispositivo",
    "DeviceModal_ViewTitle": "Visualizar dispositivo",
    "DeviceModal_PromptMessage": "Você tem alterações não salvas no dispositivo. Deseja sair sem salvar?",
    "DeviceModal_PromptConfirm": "Saída",
    "DeviceModal_PromptCancel": "Cancelar",
    "DeviceModal_Tab_General": "Detalhes",
    "DeviceModal_Tab_Advanced": "Avançado",
    "DeviceModal_Tab_Monitoring": "Monitoramento",
    "DeviceModal_Tab_DeviceMembers": "Membros do dispositivo",
    "DeviceModal_Tab_AgentMembers": "Membros Agentes",
    "DeviceModal_Tab_DnisMembers": "DNIS",
    "DeviceModal_Tab_LinkedEntities": "Entidades Vinculadas",
    "DeviceModal_Loading": "Carregando...",
    "DeviceModal_Button_Close": "Fechar",
    "DeviceModal_Button_Cancel": "Cancelar",
    "DeviceModal_Button_Save": "Salvar",
    "DeviceModal_RequestFailed": "A solicitação falhou",
    "DeviceModal_General_IdentifierGuid": "Identificador (GUID)",
    "DeviceModal_General_IdentifierPlaceholder": "[Atribuído automaticamente]",
    "DeviceModal_General_GuidPendingHelp": "O identificador é atribuído após o dispositivo ser salvo.",
    "DeviceModal_General_DeviceNumber": "Número do dispositivo",
    "DeviceModal_General_DeviceNumberRequired": "É necessário o número do dispositivo.",
    "DeviceModal_General_Description": "Descrição",
    "DeviceModal_General_DescriptionRequired": "É necessário descrever o processo.",
    "DeviceModal_General_DeviceType": "Tipo de dispositivo",
    "DeviceModal_General_DeviceTypeRequired": "É necessário especificar o tipo de dispositivo.",
    "DeviceModal_General_Partition": "Partição",
    "DeviceModal_General_PartitionRequired": "É necessário particionar o disco.",
    "DeviceModal_General_None": "Nenhum",
    "DeviceModal_General_IDOnTelSys": "ID no servidor de telefonia",
    "DeviceModal_General_IDOnTelSys_Broadworks": "ID de usuário BroadWorks",
    "DeviceModal_General_IDOnTelSys_Webex": "ID do usuário que está chamando o Webex",
    "DeviceModal_General_IDOnTelSys_MsTeams": "ID de usuário do MSTeams",
    "DeviceModal_General_IDOnTelSys_Panasonic": "ID no servidor de telefonia",
    "DeviceModal_General_IDOnTelSys_M6": "OID no servidor telefônico",
    "DeviceModal_General_IDOnTelSysOwner": "ID do grupo proprietário",
    "DeviceModal_General_IDOnTelSysDivision": "Departamento Proprietário (Caminho Completo)",
    "DeviceModal_General_InternalExtension": "Endereço de discagem interna",
    "DeviceModal_General_TelSysUserID": "ID de usuário do servidor de telefonia",
    "DeviceModal_General_TelSysUserID_WebexCiscoCommonIdentity": "Identidade Comum da Cisco",
    "DeviceModal_General_TelSysUserID_MsTeamsUpnUrn": "Nome principal do usuário (URN)",
    "DeviceModal_General_TelSysPassword": "Senha do servidor de telefonia",
    "DeviceModal_General_TelSysMonitorPassword": "Senha do monitor",
    "DeviceModal_General_PrimaryEmail": "Endereço de e-mail principal",
    "DeviceModal_General_UpdateExistingItems": "Atualize os itens existentes caso sejam encontrados duplicados.",
    "DeviceModal_Monitoring_OverrideMonitoring": "Ignorar monitoramento (não monitorado)",
    "DeviceModal_Monitoring_DisableRTMonitoring": "Desativar monitoramento em tempo real",
    "DeviceModal_Members_DeviceNumber": "Número do dispositivo",
    "DeviceModal_Members_Description": "Descrição",
    "DeviceModal_Members_AgentNumber": "Número do agente",
    "DeviceModal_Members_Actions": "Ações",
    "DeviceModal_Members_Add": "Adicionar membro",
    "DeviceModal_Members_AddHotkey": "Adicionar membro (Ctrl+Enter)",
    "DeviceModal_Members_Remove": "Remover membro",
    "DeviceModal_Members_Search": "Pesquisar membros",
    "DeviceModal_Members_NoDeviceMembers": "Nenhum membro do dispositivo",
    "DeviceModal_Members_NoAgentMembers": "Nenhum agente membro",
    "DeviceModal_Members_DnisNumber": "Número DNIS",
    "DeviceModal_Members_AddDnis": "Adicionar DNIS",
    "DeviceModal_Members_AddDnisHotkey": "Adicionar DNIS (Ctrl+Enter)",
    "DeviceModal_Members_NoDnisMembers": "Nenhuma associação com DNIS",
    "DeviceModal_LinkedEntities_Loading": "Carregando entidades vinculadas…",
    "DeviceModal_LinkedEntities_Empty": "Nenhum",
    "DeviceModal_LinkedEntities_Section_Groups": "Associações de grupo",
    "DeviceModal_LinkedEntities_Section_Users": "Usuários associados",
    "DeviceModal_LinkedEntities_Column_GroupId": "Grupo",
    "DeviceModal_LinkedEntities_Column_Description": "Descrição",
    "DeviceModal_LinkedEntities_Column_UserId": "Usuário"
}